/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import { StyleProvider } from "@ant-design/cssinjs"
import { ConfigProvider, Layout } from "antd"
import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import theme from "../styles/theme"
import BaseFooter from "./footer"
import BaseHeader from "./header"

const { Header, Footer, Content } = Layout

const BaseLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <StyleProvider layer>
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: theme.colorHighlight,
            colorBgBase: theme.colorBgBase,
            colorTextBase: theme.colorTextBase,
            colorHighlight: theme.colorHighlight,
            // Explicit font stack prevents OS-level font differences between
            // Linux (DejaVu/Noto), Windows (Segoe UI) and macOS (SF Pro).
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", "Liberation Sans", "Helvetica Neue", Arial, "Noto Sans", sans-serif',
          },
        }}
      >
        <Layout style={{ minHeight: "100vh", background: theme.colorBgBase }}>
          <Header
            style={{
              display: "flex",
              height: "auto",
              width: "100%",
              background: theme.colorBgBase,
              padding: "0",
            }}
          >
            <BaseHeader siteTitle={data.site.siteMetadata?.title || `Title`} />
          </Header>
          <Content style={{ padding: "1rem 2rem" }}>{children}</Content>
          <Footer
            style={{
              background: theme.primaryColorFade1,
              textAlign: "center",
              padding: "0rem",
            }}
          >
            <BaseFooter />
          </Footer>
        </Layout>
      </ConfigProvider>
    </StyleProvider>
  )
}

export default BaseLayout
